import { styled } from '@mui/material/styles';
import AppChart from 'react-apexcharts';

export const Chart = styled(AppChart)``;
